require("source-map-support").install(), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("TextLink", [], t) : "object" == typeof exports ? exports.TextLink = t() : e.TextLink = t();
}(this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 435);
  }({
    0: function _(e, t) {
      e.exports = require("react");
    },
    1: function _(e, t) {
      e.exports = require("prop-types");
    },
    11: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
    },
    125: function _(e, t, n) {
      "use strict";

      var r = n(6),
          o = n.n(r),
          i = n(11),
          u = n.n(i),
          c = n(3),
          f = n.n(c),
          a = n(0),
          s = n.n(a),
          p = n(1),
          l = n.n(p),
          d = n(2);

      function b(e, t) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function y() {
        var e = f()(["\n  appearance: none;\n\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  text-decoration: none;\n\n  transition: color .15s ease-in-out;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:visited {\n    color: ", ";\n  }\n\n  &:hover, &:focus, &:visited:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n"]);
        return y = function y() {
          return e;
        }, e;
      }

      var m = n.n(d).a.span(y(), function (e) {
        return e.theme.colors.brand;
      }, function (e) {
        return e.theme.fonts.Body1.fontFamily;
      }, function (e) {
        return e.theme.fonts.Body1.fontSize;
      }, function (e) {
        return e.weight;
      }, function (e) {
        return e.theme.colors.brand;
      }, function (e) {
        return e.theme.colors.brand160;
      }),
          x = function x(e) {
        var t = e.text,
            n = e.weight;
        return s.a.createElement(m, {
          weight: n
        }, t);
      };

      x.defaultProps = {
        weight: "normal"
      };

      var h = function h(e) {
        var t = e.render,
            n = e.text,
            r = e.weight;
        return t(function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? b(Object(n), !0).forEach(function (t) {
              o()(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }({}, u()(e, ["render", "text", "weight"]), {
          style: {
            textDecoration: "none"
          },
          children: x({
            text: n,
            weight: r
          })
        }));
      };

      h.propTypes = {
        text: l.a.string.isRequired,
        render: l.a.func.isRequired,
        weight: l.a.oneOf(["normal", "600", "bold"])
      }, h.defaultProps = {
        weight: "normal"
      }, h.displayName = "TextLink", t.a = h;
    },
    2: function _(e, t) {
      e.exports = require("styled-components");
    },
    208: function _(e, t, n) {
      "use strict";

      n.r(t);
      var r = n(125);
      t.default = r.a;
    },
    3: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    435: function _(e, t, n) {
      e.exports = n(208);
    },
    6: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/defineProperty");
    }
  });
});